import {forwardRef, useImperativeHandle, useState} from "react";
import {Modal} from "antd";
import {imgPathPerfix} from "../../utils";
import {useTranslation} from "react-i18next";
import {IconClose} from "@/Icon";

const DialogFrameTips = forwardRef((prop:{onCreateFrame:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))
    const [isShowDialog,setIsShowDialog] = useState(false);
    const {t} = useTranslation();

    const onShowDialog = ()=>{
        setIsShowDialog(true)
    }
    return(
        <Modal centered={true} visible={isShowDialog} closable={false} closeIcon={<IconClose/>} footer={''} onCancel={(e)=>setIsShowDialog(false)} width='468px' style={{height:'504px'}}>
            <div className='flex-column-center' style={{padding:'0 20px'}}>
                <img style={{width:'260px',height:'260px'}} src={imgPathPerfix()+'frame_tips.png'}/>
                <span className='font-family-medium' style={{fontSize:'14px'}}>{t("Make precise presentations")}</span>
                <span className='mt-12' style={{color:'#666666',textAlign:'center'}}>{t("Customize your present")}</span>
                <div className='flex-center cursor-pointer' style={{color:'white',height:'38px',background:'#3670F7',borderRadius:'8px',minWidth:'292px',marginTop:'32px'}} onClick={()=>{
                    setIsShowDialog(false);
                    prop.onCreateFrame();
                }}>
                    <img className='img-mini-small-10' src={imgPathPerfix()+'tree_frame_white.png'}/>
                    <span className='ml-6'>{t("Create frame")}</span>
                </div>
            </div>
        </Modal>
    )
})

export default DialogFrameTips;